import Axios from "axios";
import { ResourceGenerator } from "@swan/api";

const UserService = ResourceGenerator(
  Axios,
  "auth/administration/policies/users"
);

export default UserService;
